import { Vue, Component } from 'vue-property-decorator';
import { toI18n } from '@/utils/commonUtils';

@Component
export default class PrivacyAccessHistoriesGrid extends Vue {
  public gridProps: any = {
    options: {
      header: {
        height: 33,
        background: '#ccc',
      },
      columnOptions: {
        minWidth: 50,
        resizable: true,
      },
      displayRowCount: 30,
      isInitialRequest: true,
      keyColumnName: 'key',
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        centerAlign: true,
      },
      copyOptions: {
        useFormattedValue: true,
      },
    },
    keyColumnName: 'key',
    columnOptions: {
      useFormattedValue: true,
    },
    showDummyRows: true,
    columns: [
      {
        header: toI18n(this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_MALL')),
        name: 'mallName',
        align: 'center',
      },
      {
        header: toI18n(this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ACCESS_DATE_TIME')),
        name: 'accessDateTime',
        align: 'center',
      },
      {
        header: toI18n(this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_IP')),
        name: 'ip',
        align: 'center',
        formatter: data => {
          if (data.row.workingType === 'BLOCK') return '-';
          return data.value;
        },
      },
      {
        header: toI18n(this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ADMIN_ID')),
        name: 'adminId',
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.adminStatus === 'DELETE') {
            return `<span style="font-style: italic; color: gray;">${data.value}</span>`;
          }
          if (data.row.workingType === 'BLOCK') return this.$t('NOTICE_CATEGORY_SYSTEM');
          return data.value;
        },
      },
      {
        header: toI18n(this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ACCESS_URL')),
        name: 'menuUri',
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.workingType === 'BLOCK') {
            return '-';
          } else {
            return !!data.value ? `${window.location.origin}${data.value}` : '';
          }
        },
      },
      {
        header: toI18n(this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_WORKING_TYPE_DESCRIPTION')),
        name: 'workingTypeDescription',
        align: 'center',
        formatter: (data: any): any => {
          let value = data.value;
          let bDetail = false;

          if ((this.$refs.contentTop as any).focusTableTabName === 'customTab') {
            switch (data.row.workingType) {
              case 'SEARCH':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_SEARCH')}`;

                if (data.row.workingDetail?.count > 0) {
                  bDetail = true;
                }
                break;
              case 'DOWNLOAD':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_EXCEL_DOWNLOAD')}`;
                bDetail = true;
                break;
              case 'UPLOAD':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_EXCEL_UPLOAD')}`;
                bDetail = true;
                break;
              case 'CREATE':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_EXCEL_CREATE')}`;
                bDetail = true;
                break;
              case 'ADD':
                bDetail = true;
                break;
              case 'DELETE':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_DELETE')}`;
                bDetail = true;
                break;
              case 'CHANGE':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_CHANGE')}`;
                bDetail = true;
                break;
            }
          } else {
            switch (data.row.workingType) {
              case 'SEARCH':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_SEARCH')}`;

                if (data.row.workingDetail?.count > 0) {
                  bDetail = true;
                }
                break;
              case 'ADD':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ADD')}`;
                bDetail = true;
                break;
              case 'DOWNLOAD':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_EXCEL_DOWNLOAD')}`;
                bDetail = true;
                break;
              case 'CERTIFICATION':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_CERTIFICATION')}`;
                bDetail = true;
                break;
              case 'DELETE':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_DELETE')}`;
                bDetail = true;
                break;
              case 'CHANGE':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_CHANGE')}`;
                bDetail = true;
                break;
              case 'BLOCK':
                value = `${window.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_BLOCK')}`;
                bDetail = true;
                break;
            }
          }

          return `${value}${
            bDetail
              ? ' <a href="#" class="workDetailBtn" style="width: 18px; height: 18px; margin-top: 2px; display: inline-block; ">상세</a>'
              : ''
          }`;
        },
      },
    ],
  };
}
